import React from "react";
import { Link } from "react-router-dom";
import "./componentCss/background.css";
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />
function Index() {
  return (
    <div>

      {/* 🔹 Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light fixed-top custom-navbar">
        <div className="container">
          <div className="navbar-brand fw-bold text-white">
            CABLE TV PAY
          </div>

          <div className="ms-auto">
            <Link className="btn btn-login" to="/login">
              <i className="fas fa-sign-in-alt me-2" />
              Operator Login
            </Link>
          </div>
        </div>
      </nav>

      {/* 🔹 Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT */}
            <div className="col-md-6 text-white">
              <h1 className="hero-title">
                Cable TV Billing Made Simple
              </h1>
              <p className="hero-subtitle">
                Manage customers, track payments & send SMS instantly
              </p>

          <div className="hero-actions">

  {/* Get Started */}
  <Link to="/login" className="btn primary-btn">
    Get Started
  </Link>

  {/* Call */}
  <a href="tel:+918124124555" className="icon-btn call-btn">
    <i className="fas fa-phone-alt"></i>
    <span>Call</span>
  </a>

  {/* WhatsApp */}
  <a
    href="https://wa.me/918124124555"
    target="_blank"
    rel="noopener noreferrer"
    className="icon-btn whatsapp-btn"
  >
    <i className="fab fa-whatsapp"></i>
    <span>Chat</span>
  </a>

</div>
            </div>

            {/* RIGHT */}
            <div className="col-md-6 text-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1041/1041880.png"
                alt="cable"
                className="hero-img"
              />
            </div>

          </div>
        </div>
      </section>

      {/* 🔹 Features */}
      <section className="features-section">
        <div className="container text-center">
          <h2 className="fw-bold mb-5">Features</h2>

          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="feature-card">
                <i className="fas fa-users fa-2x mb-3"></i>
                <h5>Customer Management</h5>
                <p>Manage all customers easily</p>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="feature-card">
                <i className="fas fa-wallet fa-2x mb-3"></i>
                <h5>Payment Tracking</h5>
                <p>Track paid & unpaid customers</p>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="feature-card">
                <i className="fas fa-chart-line fa-2x mb-3"></i>
                <h5>Reports</h5>
                <p>Generate smart reports</p>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* 🔹 Pricing & Support */}
      <section className="pricing-section">
  <div className="container text-center">
    <h2 className="fw-bold mb-5 section-title">Plans & Support</h2>

    <div className="row justify-content-center">

      {/* 🔥 Pricing (Highlight Card) */}
      <div className="col-md-4 mb-4">
        <div className="modern-card highlight-card">
          <div className="icon-circle">
            <i className="fas fa-rupee-sign"></i>
          </div>
          <h4>Pricing</h4>
          <p className="price">₹1.30 / Active Customer</p>
          <ul>
            <li>✔ Paid SMS</li>
            <li>✔ Unpaid SMS</li>
          </ul>
        </div>
      </div>

      {/* Support */}
      <div className="col-md-4 mb-4">
        <div className="modern-card">
          <div className="icon-circle">
            <i className="fas fa-headset"></i>
          </div>
          <h4>24/7 Support</h4>
          <p>Anytime assistance</p>
          <p className="support">📞 +91 9876543210</p>
        </div>
      </div>

      {/* Why Us */}
      <div className="col-md-4 mb-4">
        <div className="modern-card">
          <div className="icon-circle">
            <i className="fas fa-bolt"></i>
          </div>
          <h4>Why Us?</h4>
          <ul>
            <li>✔ Fast</li>
            <li>✔ Secure</li>
            <li>✔ Easy</li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</section>

      {/* 🔹 About */}
      <section className="about-section">
        <div className="container text-center">
          <h2 className="fw-bold mb-3">About Us</h2>
          <p>
            Cable TV Pay helps operators manage billing, customers,
            and SMS notifications in one simple platform.
          </p>
        </div>
      </section>

      {/* 🔹 Footer */}
      <footer className="footer text-center">
        <p>© 2026 Cable TV Pay | SVS Infotech</p>
      </footer>

    </div>
  );
}

export default Index;

